export const ResolutionLevelEnum = {
    None: -1,
    Pais: 1,
    Regiao: 2,
    UF: 3,
    Mesorregiao: 4,
    Microrregiao: 5,
    RegiaoMetropolitana: 6,
    Municipio: 7,
    Distrito: 8,
    Subdistrito: 9,
    Bairro: 10,
    SetorCensitario: 11,
    AgrupamentoMunicipios: 12,
    AgrupamentoSetores: 13,
    AgrupamentoLivre: 14
};



// WEBPACK FOOTER //
// ./src/enuns/resolutionLevel.enum.js